import Tile from "../../Tile/Tile"
import { useEffect, useRef, useState } from "react"
import "trix"

export default function RichTextTile({
  id,
  tileSettingsModal,
  tileHeight,
  tile,
  canEdit = true,
  setIsDraggable,
  isEditable = true,
}) {
  const [isEditMode, setIsEditMode] = useState(false)
  const editorRef = useRef()
  const editorInputRef = useRef()
  const editorWrapperRef = useRef()
  const richTextEditorWrapperClasses =
    "[&_.trix-button--icon-code]:hidden [&_.trix-button-group--file-tools]:hidden"

  useEffect(() => {
    const trixToolbar =
      editorWrapperRef.current.querySelectorAll("trix-toolbar")[0]
    const trixToolbarButtons = trixToolbar.querySelectorAll(
      ".trix-button-row button.trix-button--icon"
    )
    const trixEditor = editorWrapperRef.current.querySelector("trix-editor")

    // Editing off by default
    trixEditor.editor.element.setAttribute("contentEditable", false)
    trixToolbar.style.display = "none"

    // Spacing Removed
    trixToolbar.querySelector(".trix-button-group-spacer").remove()
    trixToolbar.querySelector(".trix-button-row").style.justifyContent =
      "initial"
    trixToolbar.querySelector(".trix-button-row").style.overflow = "hidden"
    trixToolbar.querySelector(
      ".trix-button-group--block-tools"
    ).style.marginLeft = "0"
    trixToolbar.querySelector(
      ".trix-button-group--history-tools"
    ).style.marginLeft = "0"

    // Adjust button sizes
    Array.from(trixToolbarButtons).forEach((button) => {
      button.style.width = "1.70rem"
      button.style.height = "1.45rem"
    })

    // positioning center, styling the toolbar just below the header
    trixToolbar.className =
      "absolute top-[40px] w-[342px] left-1/2 ml-[-170px] bg-white"

    const textToolsButtonGroup = trixToolbar.querySelector(
      ".trix-button-group--text-tools"
    )
    const blockToolsButtonGroup = trixToolbar.querySelector(
      ".trix-button-group--block-tools"
    )
    const historyToolsButtonGroup = trixToolbar.querySelector(
      ".trix-button-group--history-tools"
    )

    textToolsButtonGroup.className += " mb-[0px!important] h-[25px] mr-[5px]"
    blockToolsButtonGroup.className += " mb-[0px!important] h-[25px] mr-[5px]"
    historyToolsButtonGroup.className += " mb-[0px!important] h-[25px] mr-[5px]"
  }, [])

  useEffect(() => {
    // New tiles can load in with cached content
    // Manually set the correct values when tiles change
    editorWrapperRef.current.querySelector("trix-editor").innerHTML = tile.body
  }, [tile])

  async function handleOnHide() {
    await tile.deleteTile()
  }

  async function handleSave() {
    const localData = { ...tile, body: editorInputRef.current.value }
    await tile.update(
      {
        overview_tile: {
          content: editorInputRef.current.value,
        },
      },
      localData
    )

    handleEditMode({ saving: true })
  }

  function positionToTop() {
    editorRef.current.scrollTop = 0
  }

  async function undoProgress() {
    const numberOfLetters = editorInputRef.current.value.length
    const editorElement = editorWrapperRef.current.querySelector("trix-editor")
    editorElement.editor.setSelectedRange([0, numberOfLetters])
    editorElement.editor.deleteInDirection("forward")
    editorElement.editor.insertHTML(tile.body)
  }

  async function handleEditMode({ saving }) {
    if (!saving) {
      undoProgress()
    }

    setIsEditMode(!isEditMode)
    setIsDraggable && setIsDraggable(isEditMode)

    const trixToolbar = editorWrapperRef.current.querySelector("trix-toolbar")

    editorWrapperRef.current
      .querySelector("trix-editor")
      .editor.element.setAttribute("contentEditable", !isEditMode)

    if (!isEditMode) {
      trixToolbar.style.display = "block"
    } else {
      trixToolbar.style.display = "none"
    }

    positionToTop()
  }

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  const tileHeightParameters = {
    1: { height: "312px" },
    2: { height: "744px" },
    3: { height: "1152px" },
    4: { height: "1560px" },
  }

  const { height } = tileHeightParameters[tileHeight]

  return (
    <Tile
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      handleEditMode={isEditable && handleEditMode}
      handleSave={isEditable && handleSave}
      isEditMode={isEditMode}
      id={tile.id}
      title={tile.name}
      canEdit={canEdit}
    >
      <div
        ref={editorWrapperRef}
        className={`prose max-w-none ${richTextEditorWrapperClasses}`}
      >
        <input
          type="hidden"
          id={`trix-tile-${id}`}
          ref={editorInputRef}
          value={tile.body || ""}
        />
        <trix-editor
          class={`trix-content border border-none ${
            tile.body || isEditMode
              ? ""
              : "flex items-center justify-center italic"
          }`}
          style={{
            height: height,
            overflow: isEditMode ? "auto" : "hidden",
          }}
          ref={editorRef}
          input={`trix-tile-${id}`}
          placeholder={canEdit ? "Write something..." : "No content to show."}
        />
      </div>
    </Tile>
  )
}
